.section-title {
  color: var(--chart-300-icon-buttons);
}

gz-labeled-content gz-checkbox {
  display: block;
}
